
  $(".t4s-product__info-container .warranty-product-submit-button").on("click", function () {
    $(this).addClass('is--loading')
    var container = $(this).closest(".t4s-product__info-container");
    var variantId = container
      .find(".js-warranty-complementary-products li.grid__item.active")
      .attr("data-id");
    warrantyAddToCart(variantId);
  });

  $(document).on(
    "click",
    ".t4s-product__info-container .js-warranty-complementary-products li",
    function (e) {
      $(this).siblings().removeClass("active").end().toggleClass("active");
      var container = $(this).closest(".t4s-product__info-container");
      var variantId = container
      .find(".js-warranty-complementary-products li.grid__item.active")
      .attr("data-id");
      variantId ? useFakeBtn() : useRealBut()
    }
  );

function hasSelectedAddon() {
  return $('.spice-spa-addon-product-wrapper').find('input:checked').length > 0
}

function useRealBut() {
   $('.t4s-product__info-container form [type="submit"][name="add"]').removeClass('hide-real-button');
  $(".t4s-product__info-container .warranty-product-submit-button").hide()
}

function useFakeBtn() {
   $('.t4s-product__info-container form [type="submit"][name="add"]').addClass('hide-real-button');
  $(".t4s-product__info-container .warranty-product-submit-button").show()
}

function formteMoney(price) {
  return cart_currency_symbol.replace("{{amount}}", (price / 100).toFixed(2));
}

function oldButtonClick(params) {
  if ($(".t4s-product__info-container form button[type=submit] .sg_btn_inner_span").length > 0 && hasSelectedAddon()) {
    $(".t4s-product__info-container form button[type=submit] .sg_btn_inner_span").trigger('click.spicegems');
  } else {
    $(".t4s-product__info-container form button[type=submit][name=add]").trigger("click");
  }
}

function warrantyAddToCart(id) {
  if (!id) {
    oldButtonClick()
    $(".t4s-product__info-container .warranty-product-submit-button").removeClass('is--loading')
    return;
  }
  const data = {
    items: [
      {
        id: id,
        quantity: 1,
      },
    ],
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((cart) => {})
    .catch((error) => {
      console.error("adding to cart：", error);
    })
    .finally(() => {
      oldButtonClick()
      $(".t4s-product__info-container .warranty-product-submit-button").removeClass('is--loading')
    })
}
